import {Component} from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {User} from '../../../model/user';
import {QuestionOptions} from '../../../constants/question-options';
import {UserFormBase} from '../user-form-base/user-form-base.component';
import {CustomValidators} from '../../../validator/custom-validator';
import {Store} from '@ngrx/store';
import {selectMyCompany} from '../../../store/company/selectors/company.selectors';
import {take} from 'rxjs';


@Component({
    selector: 'app-contact-information-form',
    templateUrl: './contact-information-form.component.html',
    styleUrls: ['../../../../styles/form-input.scss'],
    providers: [{ provide: UserFormBase, useExisting: ContactInformationFormComponent }],
    standalone: false
})
export class ContactInformationFormComponent extends UserFormBase {
  QuestionOptions = QuestionOptions;

  companyStreet = '';
  companyHouseNumber = '';
  companyPostalCode = '';
  companyLocation = '';
  companyTelephoneNumber = '';

  constructor(private readonly fb: FormBuilder,
              private readonly store: Store) {
    super();
  }

  null = this.store.select(selectMyCompany).pipe(take(1)).subscribe(
    (company) => {
      this.companyStreet = company.street;
      this.companyHouseNumber = company.houseNumber;
      this.companyPostalCode = company.postalCode;
      this.companyLocation = company.location;
      this.companyTelephoneNumber = company.telephoneNumber;
    });


  formGroup = this.fb.group({
    mobileNumber: '',
    telephoneNumber: [this.companyTelephoneNumber, [Validators.required, CustomValidators.notOnlyWhitespace]],
    street: [this.companyStreet, [Validators.required, CustomValidators.notOnlyWhitespace]],
    houseNumber: [this.companyHouseNumber, [Validators.required, CustomValidators.notOnlyWhitespace]],
    postalCode: [this.companyPostalCode, [Validators.required, CustomValidators.notOnlyWhitespace]],
    location: [this.companyLocation, [Validators.required, CustomValidators.notOnlyWhitespace]],
  });


  updateUser(user: User): void {
    user.telephoneNumber = this.formGroup.value.telephoneNumber;
    user.mobileNumber = this.formGroup.value.mobileNumber;
    user.street = this.formGroup.value.street;
    user.houseNumber = this.formGroup.value.houseNumber;
    user.postalCode = this.formGroup.value.postalCode;
    user.location = this.formGroup.value.location;
  }
}
